var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from '@emotion/react';
import { tokens } from '../tokens';
export function textStyle() {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    margin: 0;\n    padding: 0;\n  "], ["\n    color: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    margin: 0;\n    padding: 0;\n  "])), tokens.colors.navy, tokens.fontFamilies.sansSerif, tokens.fontSizes.medium, tokens.fontWeights.regular, tokens.lineHeights.tight);
}
var templateObject_1;
